import React from "react";
import { Box, IconButton } from "@mui/material";
import AccountBoxIcon from "@mui/icons-material/AccountBox";

import { IGetAllEntriesRequestByValuesResponse } from "../../../../../../api/compliance/index.types";
import {
  ContainerWithLoader,
  CopyToClipboard,
  PaginationWithLimit,
} from "../../../../../../components/ui";
import TableHead from "../SearchAccountsByName/TableHead";
import { StyledHorizontalScrollDiv, StyledTable } from "../../../../../../useGeneralStyles";
import { IPaginationState } from "../../../../../../hooks/usePagination";
import { TableWrapper } from "../../../../styledComponents";

interface IProps {
  loading: boolean;
  data: IGetAllEntriesRequestByValuesResponse["data"];
  pagination: IPaginationState;
  handleChangePage: (page: number) => void;
  table_name: string;
}
const Table: React.FC<IProps> = ({ handleChangePage, pagination, loading, data, table_name }) => {
  const handleClickProfileIcon = (id: number) => window.open(`#/customer/${id}`, "_blank");

  return (
    <TableWrapper>
      <div>
        <span>
          Users found: <b>{data.count}</b>
        </span>
      </div>
      <ContainerWithLoader isLoading={loading} report={data.rows}>
        <StyledHorizontalScrollDiv>
          <StyledTable smTable tableWithoutHover noTextWrap>
            <TableHead data={data.rows} table_name={table_name} />
            <tbody>
              {data.rows.map((account) => (
                <tr key={account.id}>
                  <td>{account.id}</td>
                  <td>
                    <CopyToClipboard value={account.name} />
                  </td>
                  <Box component="td" alignItems="center" display="flex">
                    <IconButton onClick={() => handleClickProfileIcon(account.id)}>
                      <AccountBoxIcon />
                    </IconButton>
                    <CopyToClipboard value={account.email} />
                  </Box>
                  <td>
                    <CopyToClipboard value={account.phone} />
                  </td>
                </tr>
              ))}
            </tbody>
          </StyledTable>
        </StyledHorizontalScrollDiv>
        <PaginationWithLimit
          count={pagination.count}
          limit={pagination.limit}
          setLimit={pagination.setLimit}
          page={pagination.page}
          setPageState={handleChangePage}
        />
      </ContainerWithLoader>
    </TableWrapper>
  );
};

export default Table;
